module.exports = __webpack_public_path__ + "media/src/images/icons/bill-363a6c387eefe208feead23f39d26842.svg";